<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { applyTenantTheme } from '@/utils/tenantThemes';

export default {
  name: 'App',
  created() {
    applyTenantTheme();
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue